import { validateMinRange, validateMaxRange } from "../../utils";
import { getValue } from "./";
const hasValue = previewEntry => {
  const value = getValue(previewEntry);
  // console.log({ value })
  return !!value;
};
export const validateMinMaxRange = (value, minimum, maximum) => {
  const meetsMinimum = validateMinRange(minimum, value);
  const meetsMaximum = validateMaxRange(maximum, value);
  if (!meetsMinimum) {
    return `Input must be greater than or equal to ${minimum}`;
  }
  if (!meetsMaximum) {
    return `Input must be less than or equal to ${maximum}`;
  }
};
const validateCurrency = ({
  minimum,
  maximum,
  value = ''
}) => {
  const currencyNumberRegex = /^-?\d+\.?(\d{1,2})?$/;
  const strippedInput = String(value).replace(/[^\d\.]/g, '');
  const isValid = currencyNumberRegex.test(strippedInput);
  if (isValid) {
    return validateMinMaxRange(strippedInput, minimum, maximum);
  } else {
    return 'Currency input is invalid';
  }
};
const validateDecimal = ({
  minimum,
  maximum,
  value
}) => {
  const isValidDecimal = !isNaN(value);
  if (isValidDecimal) {
    return validateMinMaxRange(parseInt(value), parseInt(minimum), parseInt(maximum));
  } else {
    return 'Input is invalid';
  }
};
const validateNumber = ({
  minimum,
  maximum,
  value
}) => {
  const wholeIntergerRegex = /^-?\d+$/;
  const isValidInterger = wholeIntergerRegex.test(value);
  if (isValidInterger) {
    return validateMinMaxRange(parseInt(value), parseInt(minimum), parseInt(maximum));
  } else {
    return 'Only whole numbers are allowed';
  }
};
const validateFormat = previewEntry => {
  var errorMessage;
  const {
    style,
    mask
  } = previewEntry;
  if (hasValue(previewEntry)) {
    if (style === 4) {
      errorMessage = validateCurrency(previewEntry);
    } else {
      if (mask != 0) {
        errorMessage = validateDecimal(previewEntry);
      } else {
        errorMessage = validateNumber(previewEntry);
      }
    }
  }
  return errorMessage;
};
const hasRequiredValue = previewEntry => {
  // TODO: We should have a shared place to store standard error messages...
  const errorMessage = 'This field is required';
  const {
    required
  } = previewEntry;
  if (required && !hasValue(previewEntry)) {
    return errorMessage;
  }
};
export default [{
  validation: hasRequiredValue,
  type: 'required'
}, {
  validation: validateFormat,
  type: 'format'
}];